import type { CSSProperties } from "react";
import { cn } from "@/lib/utils";
import { COMPACT_CLIP_LINE, COMPACT_CLIP_STROKE } from "@/components/logo-paths";

/** Boîte du trombone seul dans le repère de la version compacte du logo. */
const VIEWBOX = { x: 36, y: -1, w: 93, h: 135 };

/**
 * Le trombone du logo, seul, en illustration. Il prend la couleur du texte.
 * `draw` le trace au trait quand un parent passe data-shown="true".
 */
export function TromboneClip({
  height = 96,
  draw = false,
  delay = 0,
  className,
}: {
  height?: number;
  draw?: boolean;
  delay?: number;
  className?: string;
}) {
  const style = draw
    ? ({ "--draw-delay": `${delay}ms` } as CSSProperties)
    : undefined;
  return (
    <svg
      aria-hidden="true"
      viewBox={`${VIEWBOX.x} ${VIEWBOX.y} ${VIEWBOX.w} ${VIEWBOX.h}`}
      height={height}
      width={Math.round((height * VIEWBOX.w) / VIEWBOX.h)}
      className={cn("overflow-visible", className)}
    >
      <path
        d={COMPACT_CLIP_LINE}
        pathLength={draw ? 1 : undefined}
        className={draw ? "enc-draw" : undefined}
        style={style}
        fill="none"
        stroke="currentColor"
        strokeWidth={COMPACT_CLIP_STROKE}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
